import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { CheckCircle } from 'lucide-react';
import { motion } from 'framer-motion';
export function QualificationSection() {
  const {
    t
  } = useLanguage();
  const checklist = [{
    en: 'You want a long-term tool—not a quick fix',
    es: 'Buscas una herramienta a largo plazo (no una solución rápida)'
  }, {
    en: "You're ready to discuss lifestyle changes and follow-up care",
    es: 'Estás dispuesto/a a cambios de hábitos y seguimiento'
  }, {
    en: 'You want a structured medical pathway with clear steps',
    es: 'Quieres un proceso médico con pasos claros'
  }, {
    en: "You have health concerns you'd like to review with a specialist",
    es: 'Tienes preocupaciones de salud que deseas evaluar'
  }, {
    en: 'You prefer a plan tailored to your medical history',
    es: 'Prefieres un plan según tu historial médico'
  }];
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-16 md:py-24 bg-white" data-id="element-190">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-191">
        <div className="text-center mb-12" data-id="element-192">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-193">
            {t('Is weight-loss surgery right for you?', '¿Es la cirugía bariátrica para ti?')}
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-194">
            {t('If lifestyle changes alone haven’t been enough, surgery may be an option for some patients.', 'Si la dieta y el ejercicio no han sido suficientes, la cirugía puede ser una opción para algunas personas.')}
          </p>
        </div>

        <div className="bg-slate-50 rounded-2xl p-8 md:p-10 shadow-sm border border-slate-100" data-id="element-195">
          <ul className="space-y-6" data-id="element-196">
            {checklist.map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start" data-id="element-197">
                <CheckCircle className="w-6 h-6 text-teal-600 flex-shrink-0 mt-0.5 mr-4" data-id="element-198" />
                <span className="text-lg text-slate-700 font-medium" data-id="element-199">
                  {t(item.en, item.es)}
                </span>
              </motion.li>)}
          </ul>

          <div className="mt-10 text-center" data-id="element-200">
            <button onClick={scrollToContact} className="bg-slate-900 hover:bg-slate-800 text-white px-8 py-3 rounded-lg font-semibold transition-colors shadow-md" data-id="element-201">
              {t('Discuss Your Options', 'Hablar de tus opciones')}
            </button>
          </div>
        </div>
      </div>
    </section>;
}